import { render, staticRenderFns } from "./EnviosHolerite.vue?vue&type=template&id=2565ea0a"
import script from "./EnviosHolerite.vue?vue&type=script&lang=js"
export * from "./EnviosHolerite.vue?vue&type=script&lang=js"
import style0 from "./EnviosHolerite.vue?vue&type=style&index=0&id=2565ea0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports